import messages from './messages'

/**
 * Intercept axios responses
 */
export default (http, router) => {
  http.interceptors.response.use(
    response => messages.success(response),
    error => messages.error(error, router)
  )
}
